import type { AppRouteConfig } from '../types';
import { Action } from '@/components/permissions/Action';
import { PermissionNameFor } from '@/components/permissions/Permission';
import { Resource } from '@/components/permissions/Resource';

export const adminRoutes: AppRouteConfig[] = [
  {
    path: '/admin',
    layout: 'MainLayout',
    element: 'ProtectedRoute',
    children: [
      {
        path: null,
        element: 'AdminOverview',
        index: true,
        requiredPermission: PermissionNameFor(Resource.Admin, Action.View)
      },
      {
        path: 'tenants',
        element: 'AdminTenantSettings',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Tenants, Action.View)
      },
      {
        path: 'companies/:tenantId',
        element: 'AdminCompanyDetails',
        requiredPermission: PermissionNameFor(Resource.Tenants, Action.View)
      },
      {
        path: 'companies/:tenantId/users/:userId',
        element: 'AdminCompanyUserProfile',
        requiredPermission: PermissionNameFor(Resource.Users, Action.View)
      },
      {
        path: 'tenant-packages',
        element: 'AdminTenantPackages',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Tenants, Action.Update)
      },
      {
        path: 'tenant-packages/:packageId',
        element: 'AdminTenantPackageDetails',
        requiredPermission: PermissionNameFor(Resource.Tenants, Action.Update)
      },
      {
        path: 'companies/onboarding',
        element: 'AdminCompanyOnboarding',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Tenants, Action.Create)
      },
      {
        path: 'website-templates',
        element: 'AdminWebsiteTemplates',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Admin, Action.View)
      },
      {
        path: 'sms',
        element: 'AdminSmsDashboard',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Admin, Action.View)
      },
      {
        path: 'hangfire',
        element: 'AdminHangfire',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Hangfire, Action.View)
      },
      {
        path: 'helpdesk',
        element: 'AdminHelpdesk',
        index: false,
        requiredPermission: PermissionNameFor(
          Resource.ContactRequests,
          Action.View
        )
      },
      {
        path: 'roles',
        element: 'AdminRolePermissions',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Roles, Action.View)
      },
      {
        path: 'user-logs',
        element: 'AdminUserLogs',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Users, Action.View)
      },
      {
        path: 'routes-helper',
        element: 'AdminRoutesHelper',
        index: false,
        requiredPermission: PermissionNameFor(Resource.Admin, Action.View)
      }
    ]
  }
];
